import { buttonVariants } from '@/components/ui/button'
import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert'
import { usePageInfo } from 'app/frontend/base/config/queries'
import { infoByType } from 'app/frontend/base/pages/UserDashboard/subpages/UserLinkedAccounts/components/LinkedAccount'
import { urlToMainSite } from '../utils'
import { Link } from 'react-router-dom'
import { cn } from '@/lib/utils'

interface Props {
  type: 'Discord' | 'Google'
  message?: string
  buttonOnly?: boolean
  fromProfileSettings?: boolean
}

const CompactLinkedAccount = ({
  type,
  message,
  buttonOnly = false,
  fromProfileSettings = false,
}: Props) => {
  const {
    data: { user },
  } = usePageInfo()

  const connection =
    type === 'Discord'
      ? user?.linkedAccounts?.find(
          (account) => account.displayType === 'Discord',
        )
      : user?.linkedAccounts?.find(
          (account) => account.displayType === 'Google',
        )

  if (connection) return null

  if (buttonOnly) {
    return (
      <a
        href={infoByType[type].authUrl}
        target='_blank'
        rel='noreferrer'
        className={buttonVariants({ variant: 'outline', size: 'sm' })}
      >
        Connect
      </a>
    )
  }

  return (
    <Alert className='mt-4' variant='warning'>
      <AlertTitle className='flex items-center gap-2'>
        <img src={`/images/${infoByType[type].logo}`} className='w-5' />
        {type} account required
      </AlertTitle>
      <AlertDescription className='mt-2 flex justify-between gap-2 items-center'>
        <p>{message}</p>
        {fromProfileSettings ? (
          <Link
            to='/profile'
            className={cn(
              buttonVariants({ variant: 'outline', size: 'sm' }),
              'bg-card',
            )}
          >
            Configure
          </Link>
        ) : (
          <a
            href={urlToMainSite('/profile')}
            target='_blank'
            rel='noreferrer'
            className={cn(
              buttonVariants({ variant: 'outline', size: 'sm' }),
              'bg-card',
            )}
          >
            Profile
          </a>
        )}
      </AlertDescription>
    </Alert>
  )
}

export default CompactLinkedAccount
